{
  "checklist": {
    "title": "Getting set up",
    "progress": "{{done}} of {{total}} done",
    "progressLabel": "Setup progress",
    "dismiss": "Dismiss the setup checklist"
  },
  "items": {
    "createWorkout": {
      "title": "Create your first workout",
      "hint": "Build one step by step, or let the AI draft it"
    },
    "setThresholds": {
      "title": "Set your thresholds and zones",
      "hint": "Your zones are derived from a threshold — 1 minute"
    },
    "logWellness": {
      "title": "Log how you feel today",
      "hint": "Weight, sleep, HRV or a wellness check-in, typed by hand"
    },
    "saveToLibrary": {
      "title": "Save a workout to your library",
      "hint": "Keep a session you'll repeat, ready to schedule again"
    }
  }
}
